export const publicUrl: string = process.env.PUBLIC_URL;
